import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { Button } from "react-bootstrap";
import CreateDSO from "./CreateDSO";
import DSOListing from "./DSOListing";
import { DSOContext } from "../../../context/DSOContext";
import ReactPaginate from 'react-paginate';

const DSO = () => {
  const { showCreateDSO,DSOList, setShowCreateModal,fetchDSOs } = useContext(DSOContext);
   const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
 const handlePageChange = (event) => {
    // Adjusting for zero-based index by adding 1
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };
    useEffect(() => {
    fetchDSOs("", "", perPage, currentPage);
  }, ["", "", perPage, currentPage]);
  return (
    <>
      <PageTitle activeMenu="DSO" motherMenu="Manage" />
      <div className="col-12">
        <div className="card">
          <div className="card-header d-flex justify-content-end">
            <div>
              <Button
                variant="primary"
                className="mx-2"
                onClick={() => setShowCreateModal(true)}
              >
                Add DSO <i className="fa fa-plus"></i>
              </Button>
              {showCreateDSO && (
                <CreateDSO
                // fetchData={fetchData}
                />
              )}
            </div>
          </div>
          <DSOListing currentPage={currentPage} perPage={perPage}/>
        </div>
      </div>
       <ReactPaginate
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={8}
        marginPagesDisplayed={5}
        pageCount={Math.ceil(DSOList?.total / perPage)}
        previousLabel="< previous"
        pageClassName="page-item mx-1 my-1"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link mx-1 my-1"
        nextClassName="page-item mx-1 my-1"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item mx-1 my-1"
        breakLinkClassName="page-link"
        containerClassName="pagination d-flex flex-wrap"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />
    </>
  );
};

export default DSO;
